// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unsub-btn{color:#fff;font-size:12px;font-style:normal;font-weight:700;border-radius:10px;background:#ed885c;border:1px solid #ed885c;padding:10px 15px;text-align:center;transition:all .3s ease-in-out;cursor:pointer;margin-top:30px}.unsub-btn:hover{background:transparent;color:#ed885c}.error-find{text-align:center;color:#c10015;font-size:12px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
